"use client";
/**
 * @file     MlsReciprocityLogoSvg.tsx
 * @readme   ./README.md
 * @purpose  Inline SVG for the BCRES "MLS Reciprocity" mark. Light/dark mode
 *           aware — strokes + text colour come from the theme via the SVG's
 *           `color` attribute and `currentColor` fills. Required attribution
 *           per BCRES Rules of Cooperation §8.
 */

import { useAppTheme } from "@/core/theme";

const MlsReciprocityLogoSvg = ({ height = 36 }: { height?: number }) => {
  const { mode, theme } = useAppTheme();
  const color =
    mode === "light"
      ? theme.semanticColors.textPrimary
      : theme.semanticColors.textSecondary;

  return (
    <svg
      role="img"
      aria-label="MLS Reciprocity"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1157.2 494.3"
      style={{
        height,
        width: "auto",
        display: "block",
        flexShrink: 0,
        color,
      }}
    >
      <rect
        x="76.14"
        y="35.79"
        width="1004.92"
        height="422.71"
        rx="14.17"
        ry="14.17"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="13"
      />
      <path
        d="M843.64,307.36v-69.93h-48.09v69.93h-33.3v-80.97l-22.17-3.64,118.07-72.02,44.67,24.13.02-25.78,20.09-.04c-2.26,40.46,10.95,54.37,46.5,70.03l-18.47,9.15v57.04c46.65-18.33,50.18-84.88,27.52-124.89-46.58-82.27-176.52-68.51-228.83.09-37.91,49.68-44.86,128.78-8.96,181.25,45.23,66.1,107.4,59.12,176.55,40.65,6.31-1.69,12.01-3.76,4.08,4.06-125.07,62.97-256.74-22.76-228.32-164.54,20.6-102.79,112.33-146.85,211.29-131.21,89.67,14.17,138.85,118.44,78.18,190.98-4.1,4.91-25.29,25.72-29.64,25.72h-109.18Z"
        fill="currentColor"
      />
      <text
        x="612.05"
        y="162.65"
        fill="currentColor"
        style={{
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "57.4px",
        }}
      >
        {" ®"}
      </text>
      <text
        fill="currentColor"
        style={{
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "90px",
          fontWeight: 400,
        }}
      >
        <tspan x="434.78" y="219.57">
          MLS
        </tspan>
        <tspan x="175.49" y="327.57">
          Reciprocity
        </tspan>
      </text>
    </svg>
  );
};

export default MlsReciprocityLogoSvg;
